<div class="ba-file-uploader"
  [ngClass]="{'ba-error': hasError}">
  <label for="{{id}}-input">
    {{ label }}
    <span class="sr-only">{{ screenReaderLabel }}</span>
    <span #message class="sr-only ba-upload-message" role="alert" aria-live="assertive"></span>
  </label>
  <div class="ba-upload-container">
    <div #dropzone class="ba-upload-dropzone"
      [class.dropable]="dropable"
      [ngClass]="{'ba-error': hasError}"
      [id]="id + '_dropzone'"
      (dragenter)="handleDrag($event, true)"
      (dragover)="handleDrag($event, true)"
      (dragleave)="handleDrag($event, false)"
      (drop)="drop($event)">
      <span>Dateien in diesen Bereich ziehen</span>
      <span>oder </span>
      <div class="ba-upload-control ba-btn ba-btn-ghost ba-btn-icon ba-icon-upload">
        <span aria-hidden="true">Dateien auswählen</span>
        <input #input
          type="file"
          id="{{id}}-input"
          name="file"
          multiple
          (change)="handleFileInput($event)">
      </div>
    </div>

    <ul #list class="ba-upload-files" aria-label="Liste der hochgeladenen Dateien">
      @for (file of parentForm.controls; track file; let i = $index) {
        <li
          [class.ba-upload-loading]="file.value.state == FileUploadState.LOADING"
          [class.ba-upload-success]="isSuccessfulUpload(file)"
          [class.ba-upload-error]="file.value.state == FileUploadState.ERROR"
          data-filename="{{file.value.dateiname}}">
          @if (isSuccessfulUpload(file)) {
            <span
              class="ba-title">
              <a (click)="$event.preventDefault(); download(file.value)"
                href="">{{file.value.dateiname}}
              </a>
            </span>
          }
          @if (!!file.value.validationMessage) {
            <span class="ba-title">{{file.value.dateiname}}</span>
            <div [innerHTML]=file.value.validationMessage></div>
          }
          @if (file.value.state == FileUploadState.LOADING) {
            <span class="sr-only">wird hochgeladen</span>
            <span>{{file.value.dateiname}}</span>
          }
          @if (file.value.state != FileUploadState.LOADING) {
            <button class="ba-upload-delete"
              aria-label="Datei {{file.value.name}} löschen"
              (click)="delete(file, i)">
            </button>
          }
        </li>
      }
    </ul>
  </div>
</div>
